const selectors = {
  sliderContainer: '.slider',
  pagination: '.swiper-pagination',
};
export default class CustomSlider {
  constructor(section) {
    this.el = section.el;
    this.autoplay = this.el?.querySelector('[data-autoplay]')?.dataset?.autoplay === 'true';
    this.ipstack_access_key = this.el?.querySelector('[data-ipstack_access_key]')?.dataset?.ipstack_access_key;

    // If ipstack key exists, initialize geolocation slider
    if (this.ipstack_access_key != '' && this.ipstack_access_key != undefined) {
      this.getIpAddress().then((data) => {
        this.geoLocationSlider();
      });
    } else {
      // Initialize the regular slider if ipstack key doesnt exist
      this.initializeSlider();
      this.handleEvents();
    }
  }

  initializeSlider() {
    this.sliderContainer = this.el.querySelector(selectors.sliderContainer);
    this.pagination = this.el.querySelector(selectors.pagination);

    this.slider = new Swiper(this.sliderContainer, {
      autoplay: this.autoplay
        ? {
            delay: 5500,
          }
        : false,
      loop: this.autoplay,
      speed: 450,
      keyboardControl: true,
      autoHeight: true,
      pagination: {
        el: this.pagination,
        type: 'bullets',
        clickable: true,
      },
      watchOverflow: true,
    });
  }

  // Get IP address
  getIpAddress() {
    return $.getJSON({
      url: 'https://api.ipify.org?format=json',
      success: function (json) {
        return json.ip;
      },
    });
  }

  geoLocationSlider(data) {
    return $.ajax({
      url:
        'http://api.ipstack.com/' +
        data.ip +
        '?access_key=' +
        this.ipstack_access_key,
      success: function (json) {
        /*
         * Checks if section geo_location is set to true && geo_location_state matches json.region_name && geo_location_state is not empty or geo_location_zip matches json.zip && geo_location_zip is not empty
         * If all of the above is true, remove the specific section block slide
         */
        this.slides.forEach(function (block, index) {
          if (block.geo_location === true) {
            if (
              block.geo_location_state !== '' &&
              block.geo_location_state !== json.region_name.toLowerCase()
            ) {
              this.slider.removeSlide(index);
            } else if (block.geo_location_zip !== '') {
              let zipArray = block.geo_location_zip.split(',');
              if (!zipArray.includes(json.zip)) {
                this.slider.removeSlide(index);
              }
            }
          }
        });
        // Initiate slider after removing slides
        this.initializeSlider();
      },
    });
  }

  handleEvents() {
    // Shopify theme editor updates
    document.addEventListener('shopify:section:unload', function (event) {
      this.slider.destroy();
    });

    // Shopify theme editor updates
    document.addEventListener('shopify:section:load', function (event) {
      this.sliderContainer = this.el.querySelector(selectors.sliderContainer);
      this.pagination = this.el.querySelector(selectors.pagination);

      this.slider = new Swiper(this.sliderContainer, {
        // disabling in theme editor autoplay: 5500,
        speed: 50,
        autoHeight: true,
        pagination: {
          el: this.pagination,
          type: 'bullets',
          clickable: true,
        },
        loop: false,
      });
    });

    document.addEventListener('shopify:block:select', function (event) {
      this.slider.slideTo(
        $('.slide--' + event.detail.blockId).data('slide-index')
      );
    });
  }
}
